import React, { type FC } from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import clsx from 'clsx';
import { type MultiChoiceRadioProps } from './interfaces';
import './MultiChoiceRadio.scss';

export const MultiChoiceRadio: FC<MultiChoiceRadioProps> = (props) => {
    const { options, value, onChange, direction = 'vertical', name, disabled, className } = props;

    return (
        <RadioGroup
            name={name}
            value={value}
            row={direction === 'horizontal'}
            className={clsx('ms-multi-choice-radio', `ms-multi-choice-radio--${direction}`, className)}
            onChange={(e) => onChange(e.target.value)}
        >
            {options.map((option) => (
                <FormControlLabel
                    key={option.value}
                    value={option.value}
                    label={option.label}
                    disabled={disabled}
                    control={<Radio />}
                />
            ))}
        </RadioGroup>
    );
};
